import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { Route, HashRouter as Router, Routes, Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import Spinner from 'react-bootstrap/Spinner'
import 'bootstrap/dist/css/bootstrap.min.css';

const interactives = [
  {
    name: "Ch 3: Product Substitutability, Indifference Curves, and the Marginal Rate of Substitution",
    path: "/indifference-curves-and-marginal-rate",
    Component: React.lazy(() => import('./pages/ch3-indifference-curves-and-marginal-rate')),
  },
  {
    name: "Ch 4: Cobb-Douglas Preferences and the MRS",
    path: "/cobb-douglas-preferences",
    Component: React.lazy(() => import('./pages/ch4-cobb-douglas-preferences')),
  },
  {
    name: "Ch 5: Product Substitutability and Consumer Demand",
    path: "/product-substitutability-and-consumer-demand",
    Component: React.lazy(() => import('./pages/ch5-product-substitutability-and-consumer-demand')),
  },
  {
    name: "Ch 5b: Cobb-Douglas Preferences and Consumer Demand",
    path: "/ch5b-cobb-douglas-preferences-and-consumer-demand",
    Component: React.lazy(() => import('./pages/ch5b-cobb-douglas-preferences-and-consumer-demand')),
  },
  {
    name: "Ch 6: Product Substitutability and the Demand Curve",
    path: "/product-substitutability-and-demand-curve",
    Component: React.lazy(() => import('./pages/ch6-product-substitutability-and-demand-curve')),
  },
  {
    name: "Ch 14: Quasilinear Utility, Demand, and Consumer Surplus",
    path: "/quasilinear-utility",
    Component: React.lazy(() => import('./pages/ch14-quasilinear-utility')),
  },
  {
    name: "Ch 15: Elasticity and Revenue along a Linear Demand Curve",
    path: "/elasticity-and-revenue-of-linear-demand",
    Component: React.lazy(() => import('./pages/ch15-elasticity-and-revenue-of-linear-demand')),
  },
  {
    name: "Ch 16: Tax Burden and Elasticity of Supply and Demand",
    path: "/tax-burden",
    Component: React.lazy(() => import('./pages/ch16-tax-burden')),
  },
  {
    name: "Ch 19: Input Substitutability, Isoquants, and the Technical Rate of Substitution",
    path: "/input-substitutability",
    Component: React.lazy(() => import('./pages/ch19-input-substitutability')),
  },
  {
    name: "Ch 20: Short-Run Profit Maximization and the Factor Demand Curve",
    path: "/short-run-profit-maximization-and-factor-demand-curve",
    Component: React.lazy(() => import('./pages/ch20-short-run-profit-maximization-and-factor-demand-curve')),
  },
  {
    name: "Ch 21: Input Substitutability, Cost Minimization, and Conditional Factor",
    path: "/input-substitutability-cost-minimization",
    Component: React.lazy(() => import('./pages/ch21-input-substitutability-cost-minimization')),
  },
  {
    name: "Ch 22: Cost Curves with Increasing and U-Shaped Marginal Cost",
    path: "/cost-curves-with-increasing-and-u-shaped-marginal-cost",
    Component: React.lazy(() => import('./pages/ch22-cost-curves-with-increasing-and-u-shaped-marginal-cost')),
  },
  {
    name: "Ch 23: Firm Supply with Increasing and U-Shaped Marginal Cost",
    path: "/firm-supply-with-increasing-and-u-shaped-marginal-cost",
    Component: React.lazy(() => import('./pages/ch23-firm-supply-with-increasing-and-u-shaped-marginal-cost')),
  },
  {
    name: "Ch 24: Adjustment of Industry Supply to Long-Run Equilibrium",
    path: "/adjustment-Industry-supply-to-long-run-equilibrium",
    Component: React.lazy(() => import('./pages/ch24-adjustment-Industry-supply-to-long-run-equilibrium')),
  },
  {
    name: "Ch 25: Monopoly Pricing and Elasticity of Demand",
    path: "/monopoly-pricing-and-elasticity-of-demand",
    Component: React.lazy(() => import('./pages/ch25-monopoly-pricing-and-elasticity-of-demand')),
  },
  {
    name: "Ch 35: Traffic Congestion as Externality",
    path: "/traffic-congestion-as-externality",
    Component: React.lazy(() => import('./pages/ch35-traffic-congestion-as-externality')),
  },
  {
    name: "Graph Slider Demo",
    path: "/graph-slider-demo",
    Component: React.lazy(() => import('./pages/graph-slider-demo'))
  }
]

function LandingPage() {
  return <div>
    {interactives.map(({ name, path }) => {
      return <Card key={path} body>
        <Link to={path}>{name}</Link>
      </Card>
    })}
  </div>
}

ReactDOM.render(
  <React.StrictMode>
    <Container>
      <Router>
        <Routes>
          {interactives.map(({ name, path, Component }) => {
            return <Route key={path} exact path={path} element={<Suspense fallback={<Spinner animation="border" />}>
              <Component />
            </Suspense>} />
          })}
          <Route exact path="/" element={<LandingPage />} />
        </Routes>
      </Router>
    </Container>
  </React.StrictMode>,
  document.getElementById('root')
);
